import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StatusRequest } from '../../../../core/models/request-status.model';
import { UserRegisterRequest } from './user-aux.model';
import { UserAuxConnector } from './user-aux.connector';

@Injectable({
  providedIn: 'root',
})
export class UserAuxService {
  constructor(private userAuxConnector: UserAuxConnector) {}

  register(user: UserRegisterRequest): Observable<StatusRequest> {
    return this.userAuxConnector.register(user);
  }

  getStateRegions(isoCode: string) {
    return this.userAuxConnector.getStateRegions(isoCode);
  }

  getBusinessTypes() {
    return this.userAuxConnector.getBusinessTypes();
  }

  getProductCategories() {
    return this.userAuxConnector.getProductCategories();
  }

  verifyAccount(accountNumber: string) {
    return this.userAuxConnector.verifyAccount(accountNumber);
  }

  verifyEmail(email: string) {
    return this.userAuxConnector.verifyEmail(email);
  }

  requestRole(role: string) {
    return this.userAuxConnector.requestRole(role);
  }

  requestAccount(accountNumber: string, reason: string) {
    return this.userAuxConnector.requestAccount(accountNumber, reason);
  }
}
